import { PayloadAction, createAction, createSlice } from '@reduxjs/toolkit';
import { ConnectToFathomAction, DisconnectFromFathomAction } from './types';
import { FathomTranscriptType } from '@distribute/shared/api-types/fathom';

type State = {
  isConnecting: boolean;
  isDisconnecting: boolean;
  isLoadingTranscripts: boolean;
  participants: string[];
  transcripts: FathomTranscriptType[];
};

const initialState: State = {
  isConnecting: false,
  isDisconnecting: false,
  isLoadingTranscripts: false,
  participants: [],
  transcripts: [],
};

export const { reducer, actions: reducerActions } = createSlice({
  name: 'fathom',
  initialState,
  reducers: {
    setIsConnecting: (
      state,
      { payload: isConnecting }: PayloadAction<boolean>
    ) => ({ ...state, isConnecting }),
    setIsDisconnecting: (
      state,
      { payload: isDisconnecting }: PayloadAction<boolean>
    ) => ({ ...state, isDisconnecting }),
    setIsLoadingTranscripts: (
      state,
      { payload: isLoadingTranscripts }: PayloadAction<boolean>
    ) => ({ ...state, isLoadingTranscripts }),
    setParticipants: (
      state,
      { payload: participants }: PayloadAction<string[]>
    ) => ({ ...state, participants }),
    setTranscripts: (
      state,
      { payload: transcripts }: PayloadAction<FathomTranscriptType[]>
    ) => ({ ...state, transcripts }),
  },
});

export const actions = {
  ...reducerActions,
  connectToFathom: createAction<ConnectToFathomAction>('fathom/connect'),
  disconnectFromFathom:
    createAction<DisconnectFromFathomAction>('fathom/disconnect'),
  getTranscripts: createAction('fathom/getTranscripts'),
};
